module.exports = __webpack_public_path__ + "static/about-the-program-00db752e9fc0d2296886b2ee22485689.jpg";